var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.online)?_c('span',{staticClass:"badge badge-soft-success font-size-11"},[_c('i',{staticClass:"ri-global-line mr-1"}),_vm._v(" Online ")]):_c('span',{staticClass:"badge badge-soft-info font-size-11"},[_c('i',{staticClass:"ri-store-line mr-1"}),_vm._v(" Física ")])
}
var staticRenderFns = []

export { render, staticRenderFns }